// action - mission reducer
import { current } from '@reduxjs/toolkit';
import { modifyDataMission } from 'services/mission/MissionService';
import {
    GET_MISSIONS_PENDING,
    GET_MISSIONS_SUCCESS,
    GET_MISSIONS_FAILURE,
    GET_MISSION_PENDING,
    GET_MISSION_SUCCESS,
    GET_MISSION_FAILURE,
    MISSIONS_PENDING,
    MISSIONS_FAILURE,
    UPDATE_MISSION_SUCCESS,
    GET_CURRENT_MISSION_SUCCESS,
    MISSION_ASSIGN_SUCCESS,
    MISSION_CANCEL_SUCCESS,
} from 'store/actions-type/missions';
import { v4 as uuidv4 } from 'uuid';

// initial state
const initialState = {
    list: [],
    mission: null,
    createdMissionId: null,
    currentMission: null,
    error: null,
    pending: false,
};
// ==============================|| SLICE - MISSION||============================== //

export default function missionReducer(state = initialState, action) {
    switch (action.type) {
        case MISSIONS_PENDING:
            return {
                ...state,
                pending: true,
                error: null,
            };

        case MISSIONS_FAILURE:
            return {
                ...state,
                pending: false,
                error: action.payload.error,
            };

        // action - get missions
        // case GET_MISSIONS_PENDING:
        //     return {
        //         ...state,
        //         pending: true,
        //         error: null,
        //     };
        case GET_MISSIONS_SUCCESS:
            return {
                ...state,
                pending: false,
                list: action.payload,
            };
        // case GET_MISSIONS_FAILURE:
        //     return {
        //         ...state,
        //         pending: false,
        //         error: action.payload.error,
        //     };
        // action - get mission by id
        // case GET_MISSION_PENDING:
        //     return {
        //         ...state,
        //         pending: true,
        //         error: null,
        //     };

        case GET_MISSION_SUCCESS:
            return { ...state, ...action.payload, pending: false };

        case UPDATE_MISSION_SUCCESS:
            return { ...state, ...action.payload, pending: false };
        // case GET_MISSION_FAILURE:
        //     return {
        //         ...state,
        //         pending: false,
        //         error: action.payload.error,
        //     };

        // action - get current mission
        // case GET_CURRENT_MISSION_PENDING:
        //     return {
        //         ...state,
        //         pending: true,
        //         error: null,
        //     };
        case GET_CURRENT_MISSION_SUCCESS:
            return {
                ...state,
                currentMission: action.payload,
                pending: false,
            };

        // action - assign mission
        // case MISSION_ASSIGN_PENDING:
        //     return {
        //         ...state,
        //         pending: true,
        //         error: null,
        //     };
        case MISSION_ASSIGN_SUCCESS:
            return {
                ...state,
                currentMission: action.payload,
                pending: false,
            };
        // case MISSION_ASSIGN_FAILURE:
        //     return {
        //         ...state,
        //         pending: false,
        //         error: action.payload.error,
        //     };

        // action - cancel mission
        // case MISSION_CANCEL_PENDING:
        //     return {
        //         ...state,
        //         pending: true,
        //         error: null,
        //     };
        case MISSION_CANCEL_SUCCESS:
            return {
                ...state,
                currentMission: null,
                pending: false,
            };
        // case MISSION_CANCEL_FAILURE:
        //     return {
        //         ...state,
        //         pending: false,
        //         error: action.payload.error,
        //     };

        default:
            return state;
    }
}
